/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEvent } from './IntegrationEvent';
import {
    IntegrationEventFromJSON,
    IntegrationEventFromJSONTyped,
    IntegrationEventToJSON,
    IntegrationEventToJSONTyped,
} from './IntegrationEvent';

/**
 * 
 * @export
 * @interface IntegrationEventResponse
 */
export interface IntegrationEventResponse {
    /**
     * 
     */
    data: Array<IntegrationEvent>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
    /**
     * Facility-scoped leave destination resolved from the PccSyncV2LeaveOption setting (loa or hospitalized), so the UI can label the leave apply action ("Place on LOA" vs "Place on Hospitalized").
     */
    leave_admission_status?: IntegrationEventResponseLeaveAdmissionStatusEnum;
}


/**
 * @export
 */
export const IntegrationEventResponseLeaveAdmissionStatusEnum = {
    Loa: 'loa',
    Hospitalized: 'hospitalized',
} as const;
export type IntegrationEventResponseLeaveAdmissionStatusEnum = typeof IntegrationEventResponseLeaveAdmissionStatusEnum[keyof typeof IntegrationEventResponseLeaveAdmissionStatusEnum];


/**
 * Check if a given object implements the IntegrationEventResponse interface.
 */
export function instanceOfIntegrationEventResponse(value: object): value is IntegrationEventResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function IntegrationEventResponseFromJSON(json: any): IntegrationEventResponse {
    return IntegrationEventResponseFromJSONTyped(json, false);
}

export function IntegrationEventResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(IntegrationEventFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'leave_admission_status': json['leave_admission_status'] == null ? undefined : json['leave_admission_status'],
    };
}

export function IntegrationEventResponseToJSON(json: any): IntegrationEventResponse {
    return IntegrationEventResponseToJSONTyped(json, false);
}

export function IntegrationEventResponseToJSONTyped(value?: IntegrationEventResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(IntegrationEventToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
        'leave_admission_status': value['leave_admission_status'],
    };
}

